import React, { useState, useEffect, useRef } from "react"
import 'leaflet/dist/leaflet.css'
import 'leaflet-defaulticon-compatibility/dist/leaflet-defaulticon-compatibility.webpack.css'
import 'leaflet-defaulticon-compatibility'
import * as L from 'leaflet'

import * as C from 'leaflet-coverage'
import * as CovJSON from 'covjson-reader'

import { Form, Alert } from 'react-bootstrap'

import "react-datepicker/dist/react-datepicker.css"

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { TextField } from "@mui/material";

import { parseISO } from 'date-fns'
import moment from 'moment'

import "../../../src/App.css"
// import {generatePath} from "react-router-dom";
//export const API_URL = 'https://159.162.23.57/'
//export const API_URL = 'http://10.40.2.113:8080/api/'
export const API_URL = 'https://swan.kartverket.no/api/'


const Map = () => {
  const [dates, setDates] = useState()
  const [useCases, setUsecases] = useState([])
  const [useCase, setUsecase] = useState([])
  const [thresholds, setThresholds] = useState([])
  const [threshold, setThreshold] = useState()
  //const [interval, setInterval] = useState(null)
  const [error, setError] = useState('Select use case and threshold first, then pick a valid date')
  const [dataMissing, setDataMissing] = useState('')
  const [selectedDate, setSelectedDate] = useState(moment.utc());
  const [tempDate, setTempDate] = useState(moment.utc()); // Temporary state

  // Function to round the time to the nearest 15-minute interval
  const roundToNearestQuarter = (date) => {
    return date
        .minute(Math.round(date.minute() / 15) * 15)  // Round minutes to 15-minute intervals
        .second(0)  // Reset seconds to 0
        .millisecond(0);  // Reset milliseconds to 0
  };

  const handleDateChange = (newValue) => {
    if (newValue) {
      // Round the selected date to the nearest 15-minute interval
      const roundedDate = roundToNearestQuarter(moment.utc(newValue));
      setSelectedDate(roundedDate);
    }
  };

  const handleTempChange = (newValue) => {
    if (newValue) {
      // Round the selected date to the nearest 15-minute interval
      const roundedDate = roundToNearestQuarter(moment.utc(newValue));
      setTempDate(roundedDate);
    }
  };


  useEffect(() => {
    //console.log('testing new gui')
    let threshold = 'threshold-type';
    if(useCase.length > 0) {
      threshold = 'threshold-type/' + useCase;
    }

    fetch(API_URL + threshold)
      .then(response => {
        return response.json()
      })
      .then(json => {
        console.log(json)
        setThresholds(json.theshold_types)
      })
      .catch(e => {
        console.error(e)
      })
  }, [useCase])
  useEffect(() => {
    fetch(API_URL + 'datetime-range')
      .then(response => {
        return response.json()
      })
      .then(json => {
        const selected_time = moment.utc(parseISO(json.end_time))
        setTempDate(selected_time)
        setSelectedDate(selected_time)
        const formattedStart = moment.utc(json.start_time).format("MMMM D, YYYY HH:mm:ss") + ' UTC';
        const formattedEnd = moment.utc(json.end_time).format("MMMM D, YYYY HH:mm:ss") + ' UTC';
        //setDates([parseISO(json.start_time).toUTCString(), parseISO(json.end_time).toUTCString()])
        setDates([formattedStart, formattedEnd])
        setInterval(json.interval)
      })
      .catch(e => {
        console.error(e)
      })
  }, [])
  useEffect(() => {
    fetch(API_URL + 'usecases')
      .then(response => {
        return response.json()
      })
      .then(json => {
        console.log(json)
        setUsecases(json.usecases)
      })
      .catch(e => {
        console.error(e)
      })
  }, [])

  const mapRef = useRef(null)
  useEffect(() => {
    const layerName = 'topo4' // topo4, topo4graatone, norges_grunnkart, norges_grunnkart_graatone, sjokartraster2
    const cacheUrl = 'https://opencache.statkart.no/gatekeeper/gk/gk.open_gmaps?layers=' + layerName + '&zoom={z}&x={x}&y={y}'
    const kv = L.tileLayer(cacheUrl, {
      id: 'kv',
      attribution: '<a href="https://kartverket.no/">Kartverket</a>',
    })
    const osm = L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', {
      id: 'osm',
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
    })
    mapRef.current = L.map('kart', {
      center: [60, 10],
      zoom: 3,
      layers: [osm, kv]
    })
  }, [])

  useEffect(
    () => {
      mapRef.current.eachLayer(function (layer) {
        if (layer.options.id === 'covjson') {
          mapRef.current.removeLayer(layer)
        }
      })
      let tid = selectedDate.toISOString()
      tid = tid.slice(0, -5)
      if (useCase.length === 0) {
        setError('Select Use Case')
      } else if (!threshold) {
        setError('Select Threshold Type')
      }
      else {
        setError()
      }
      const bbox = mapRef.current.getBounds().toBBoxString()
      let layer
      CovJSON.read(
        API_URL + 'collections/' + useCase + '/area?datetime=' + tid + '%2B00:00' + '&coords=POLYGON((' + bbox + '))&parameter_name=' + threshold + '&f=covjson'
      ).then(function (coverage) {
        setDataMissing('No data for the selected combination of date, use case and threshold type')
        layer = C.dataLayer(coverage, { id: 'covjson', parameter: threshold })
          .on('afterAdd', function () {
            C.legend(layer).addTo(mapRef.current)
            setDataMissing('Data presented for given time: ' + selectedDate.format('MMMM D, YYYY HH:mm:ss') +  ' UTC')
          })
          .addTo(mapRef.current)
      }).catch(e => {
        setDataMissing('No data for the selected combination of date, use case and threshold type')
        console.error(e)
      })
      /*
      mapRef.current.on('click', function (e) {
        new C.DraggableValuePopup({
          layers: [layer]
        }).setLatLng(e.latlng).openOn(mapRef.current)
      })
      */
    },
    [useCase, threshold, selectedDate]
  )

  useEffect(() => {
    fetch('https://raw.githubusercontent.com/OSGeo/PROJ/master/docs/plot/data/coastline.geojson')
      .then(response => {
        return response.json()
      })
      .then(json => {
        L.geoJSON(json, {
          id: 'coastlines',
          zIndex: 1001,
        }).addTo(mapRef.current)
      })
      .catch(e => {
        console.error(e)
      })
  }, [])

  return <main id="mainContent">
    <div className="container">
      <div className="row">
        <div className="col">
          <div id="kart" style={ { height: "500px", width: "100%" } }></div>
          {/* <Legend legendUrl={legendUrl} /> */ }
        </div>
        <div className="col-sm">
          <h3>Arctic Space Weather</h3>

          The map shows the percentage chance of disruption due to ionospheric disturbances, for the selected use case, during a three hour interval starting at the selected date and time.
          For some use cases, you can also select the type of threshold used: &quot;pROTI&quot; uses a threshold for the strength of the ionospheric noise, while &quot;pPosErr&quot; uses a threshold for the expected position error.
          For more information, see the Info page.
          {dates ? (
              <div style={{ marginTop: '20px' }}>
                Data is available for the following time period: <br />
                {dates[0] + '  -->  ' + dates[1]}
              </div>
          ) : ''}
            <div style={{ marginTop: '20px' }}>
              <div className="btn-group">
                <Form.Select
                    aria-label="Use Case"
                    onChange={ e => setUsecase(e.target.value) }
                    style={{ width: '275px' }}
                >
                  <option value={''}>Select Use Case</option>
                  {useCases?.map(item => (
                      <option key={item.name} value={item.name}>
                        {item.name}
                      </option>
                  ))}
                </Form.Select>

                <Form.Select
                    aria-label="Threshold Type"
                    onChange={ e => setThreshold(e.target.value) }
                    style={{ width: '275px' }}
                >
                  <option value={''}>Select Threshold Type</option>
                  {thresholds?.map(item => (
                      <option key={item} value={item}>
                        {item}
                      </option>
                  ))}
                </Form.Select>
              </div>
            </div>

          <LocalizationProvider dateAdapter={AdapterMoment}  style={{ marginTop: '40px' }}>
            <DateTimePicker
                label="Select Date & Time (UTC)"
                value={tempDate}
                onChange={handleTempChange}
                onAccept={handleDateChange}
                ampm={false} // Ensures 24-hour format
                inputFormat="MMMM D, YYYY HH:mm:ss" // Use format that works with DateFnsFormat inside picker
                renderInput={(params) =>  <TextField
                    {...params} sx={{ width: "275px", marginTop: "20px" }}/>}
            />
          </LocalizationProvider>

          <Alert variant='light' style={{ marginTop: '20px' }}>
            Note that data gaps exist in the dataset, due to gaps in the input data
          </Alert>
          { error ? <Alert variant='warning'>
            { error }
          </Alert> : ''
          }
          { dataMissing ? <Alert variant={dataMissing.includes('presented') ? 'light' : 'danger'}>
            { dataMissing }
          </Alert> : ''
          }
        </div>
      </div>
    </div>
  </main>
}
export default Map
